import React from 'react'

import Translator from 'bazinga-translator'
import useCategory from 'components/GamesNavBar/hooks/useCategory'
import useSearch from 'components/GamesNavBar/hooks/useSearch'
import useCurrentCategory from 'utils/hooks/queries/games/useCurrentCategory'

import { Pill, X, SelectedFiltersBox } from './styles'

export function SelectedFilters() {
  const { search, setSearch } = useSearch()
  const { changeCategory } = useCategory()
  const { data: currentCategory } = useCurrentCategory()

  return (
    <SelectedFiltersBox>
      <Pill condition={!!search}>
        <span>
          {Translator.trans('Search')}: <b>{search}</b>
        </span>
        <X onClick={() => setSearch('')} />
      </Pill>
      <Pill condition={!!currentCategory}>
        <span>
          {Translator.trans('category', {}, 'games')}: <b>{currentCategory?.label}</b>
        </span>
        <X onClick={() => changeCategory(undefined)} />
      </Pill>
    </SelectedFiltersBox>
  )
}
